(function($) {

  $(function() {

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();

      if ( scroll >= 2 ) {
        $(".header").addClass("header--fixed");
      } else {
        $(".header").removeClass("header--fixed");
      }
    });

    $('a[href*="#"]').not('[href^="#tab"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      // On-page links
      if ( location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - $('.header').outerHeight() - $('#wpadminbar').outerHeight()
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });

  });

  function create_custom_dropdowns() {
    $('select').each(function(i, select) {
      if (!$(this).next().hasClass('dropdown')) {
        $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
        var dropdown = $(this).next();
        var options = $(select).find('option');
        var selected = $(this).find('option:selected');
        dropdown.find('.current').html(selected.data('display-text') || selected.text());
        options.each(function(j, o) {
          var display = $(o).data('display-text') || '';
          dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
        });
      }
    });
  }

  // Event listeners

  // Open/close
  $(document).on('click', '.dropdown', function(event) {
    $('.dropdown').not($(this)).removeClass('open');
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $(this).find('.option').attr('tabindex', 0);
      $(this).find('.selected').focus();
    } else {
      $(this).find('.option').removeAttr('tabindex');
      $(this).focus();
    }
  });
  // Close when clicking outside
  $(document).on('click', function(event) {
    if ($(event.target).closest('.dropdown').length === 0) {
      $('.dropdown').removeClass('open');
      $('.dropdown .option').removeAttr('tabindex');
    }
    event.stopPropagation();
  });
  // Option click
  $(document).on('click', '.dropdown .option', function(event) {
    $(this).closest('.list').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var text = $(this).data('display-text') || $(this).text();
    $(this).closest('.dropdown').find('.current').text(text);
    $(this).closest('.dropdown').prev('select').val($(this).data('value')).trigger('change');
  });

  // Keyboard events
  $(document).on('keydown', '.dropdown', function(event) {
    var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
    // Space or Enter
    if (event.keyCode === 32 || event.keyCode === 13) {
      if ($(this).hasClass('open')) {
        focused_option.trigger('click');
      } else {
        $(this).trigger('click');
      }
      return false;
      // Down
    } else if (event.keyCode === 40) {
      if (!$(this).hasClass('open')) {
        $(this).trigger('click');
      } else {
        focused_option.next().focus();
      }
      return false;
      // Up
    } else if (event.keyCode === 38) {
      if (!$(this).hasClass('open')) {
        $(this).trigger('click');
      } else {
        focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
        focused_option.prev().focus();
      }
      return false;
    // Esc
    } else if (event.keyCode === 27) {
      if ($(this).hasClass('open')) {
        $(this).trigger('click');
      }
      return false;
    }
  });

  $(document).ready(function() {
    create_custom_dropdowns();
  });

  $('.mfp-video').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    iframe: {
      patterns: {
        vimeo: {
          index: 'vimeo.com/',
          id: function(url) {
            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
            if ( !m || !m[5] ) {
              return null;
            }
            return m[5];
          },
          src: 'https://player.vimeo.com/video/%id%?autoplay=1'
        },
        youtu: {
          index: 'youtu.be',
          id: function( url ) {
            // Capture everything after the hostname, excluding possible querystrings.
            var m = url.match( /^.+youtu.be\/([^?]+)/ );
            if ( null !== m ) {
              return m[1];
            }
            return null;
          },
          // Use the captured video ID in an embed URL.
          // Add/remove querystrings as desired.
          src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
        }
      }
    }
  });

  $('.section-content__card').each(function() {
    var card = $(this);
    $(this).find('.read-more').on('click', function(e) {
      e.preventDefault();

      card.find('.card__excerpt').toggleClass('card__excerpt--active');

      if ( $(this).text() == 'Read more' ) {
        card.addClass('active');
        $(this).text('Read less');
      } else {
        card.removeClass('active');
        $(this).text('Read more');
      }
    });
  });

  $(function() {
    var hash = window.location.hash;
    if (hash) {
      var element = $(hash);
      if ( element.length ) {
        element.next('.section-content__card').find('.read-more').trigger('click');
      }
    }
  });

})(jQuery);
